import Button from "@material-ui/core/Button";
import React, { FC } from "react";
import { EditButton, Loading, ShowActionsProps, TopToolbar } from "react-admin";
import { apiUrl } from "../../dataProvider";
import useFinance from "../../hooks/useFinance";
import { Booking } from "../../types";
import AcceptCancellationDialog from "./AcceptCancellationDialog";
import AcceptDialog from "./AcceptDialog";
import CancelDialog from "./CancelDialog";
import CancelNoUsageDialog from "./CancelNoUsageDialog";
import CancelReportDialog from "./CancelReportDialog";
import FinishAllocating from "./FinishAllocatingDialog";
import FinishDeliveringDialog from "./FinishDeliveringDialog";
import GenrateIssue from "./GenerateIssue";
import OutboundTransactionNumbersDialog from "./OutboundTransactionNumbersDialog";
import ReviseTopUpDialog from "./ReviseTopUpDialog";
import SendInvoiceDialog from "./SendInvoiceDialog";
import SubmitReportDialog from "./SubmitReportDialog";
import TopUpDialog from "./TopUpDialog";
import UnFinishAllocating from "./UnFinishAllocatingDialog";
import { OrderActions, can } from "./util";

export const ShowActions: FC<ShowActionsProps> = ({
  basePath,
  data,
  resource,
}) => {
  const booking = data as Booking;
  const isFinance = useFinance();

  React.useEffect(() => console.log("isFinance :>> ", isFinance), [isFinance]);

  if (!booking) {
    return <Loading />;
  }

  return (
    <TopToolbar>
      {process.env.REACT_APP_COMPANY_CODE === "STMY" && (
        <>
          {!isFinance && booking.status === "accepted" && (
            <OutboundTransactionNumbersDialog data={booking} />
          )}
        </>
      )}

      {!isFinance && can(booking, OrderActions.REVISE) && (
        <GenrateIssue data={booking} />
      )}

      {!isFinance && can(booking, OrderActions.REVISE) && (
        <EditButton
          basePath={basePath}
          record={data}
          label="Revise"
          icon={<></>}
          color="primary"
        />
      )}

      <Button
        onClick={() => {
          window
            .open(`${apiUrl}/print/bookings/${booking.id}`, "_blank")
            ?.print();
        }}
      >
        Print
      </Button>

      {!isFinance && can(booking, OrderActions.ACCEPT) && (
        <AcceptDialog data={booking} />
      )}

      {!isFinance && can(booking, OrderActions.UNFINISH_ALLOCATING) && (
        <UnFinishAllocating data={booking} />
      )}

      {!isFinance && can(booking, OrderActions.FINISH_ALLOCATING) && (
        <FinishAllocating data={booking} />
      )}

      {!isFinance && can(booking, OrderActions.FINISH_DELIVERING) && (
        <FinishDeliveringDialog data={booking} />
      )}

      {!isFinance &&
        (() => {
          // Check if all reports have been submitted (dates.length === reports.length)
          const datesCount =
            booking.dates && Array.isArray(booking.dates)
              ? booking.dates.length
              : booking.date
                ? 1
                : 0;
          const reportsCount =
            booking.reports && Array.isArray(booking.reports)
              ? booking.reports.length
              : 0;
          const allReportsSubmitted =
            datesCount > 0 && datesCount === reportsCount;

          // Show button if:
          // 1. Status allows SUBMIT_REPORT action (via can() function), OR
          // 2. Status is "report_submitted" but not all surgery dates have reports yet
          const canSubmitReport =
            can(booking, OrderActions.SUBMIT_REPORT) ||
            (booking.status === "report_submitted" && !allReportsSubmitted);

          // Only show button if allowed and not all reports have been submitted
          return canSubmitReport && !allReportsSubmitted ? (
            <SubmitReportDialog data={booking} />
          ) : null;
        })()}

      {/* Finance can only send invoice */}
      {can(booking, OrderActions.SEND_INVOICE) &&
        (() => {
          const datesCount =
            booking.dates && Array.isArray(booking.dates)
              ? booking.dates.length
              : booking.date
                ? 1
                : 0;
          const reportsCount =
            booking.reports && Array.isArray(booking.reports)
              ? booking.reports.length
              : 0;
          const allReportsSubmitted =
            datesCount > 0 && datesCount === reportsCount;

          // After top-up, finance must send invoice even if dates/reports counts
          // no longer align the same way as pre-invoice flow.
          const canShowSendInvoice =
            allReportsSubmitted || booking.status === "topped_up";

          return canShowSendInvoice ? (
            <SendInvoiceDialog data={booking} />
          ) : null;
        })()}

      {/* Cancel Invoice button: only show when status is invoiced or invoiced_topped_up */}
      {/*
      {!isFinance && (booking.status === "invoiced" || booking.status === "invoiced_topped_up") && (
        <CancelInvoiceDialog data={booking} />
      )}
      */}

      {/* Cancel Report button: only show when status is report_submitted */}
      {!isFinance && booking.status === "report_submitted" && (
        <CancelReportDialog data={booking} />
      )}

      {!isFinance && can(booking, OrderActions.TOP_UP) && (
        <TopUpDialog data={booking} />
      )}

      {!isFinance && can(booking, OrderActions.CANCEL) && (
        <CancelDialog data={booking} />
      )}

      {!isFinance && can(booking, OrderActions.NO_USAGE) && (
        <CancelNoUsageDialog data={booking} />
      )}

      {!isFinance && can(booking, OrderActions.CANCEL_REQUEST) && (
        <AcceptCancellationDialog data={booking} />
      )}

      {!isFinance &&
        (booking.status === "topped_up" ||
          booking.status === "invoiced_topped_up") && (
          <ReviseTopUpDialog data={booking} />
        )}
    </TopToolbar>
  );
};
